import nerdNahled from "./nerd-nahled-web.png"
import josefNahled from "./josef-nahled-web.png"
import karelNahled from "./karel-nahled-web.png"
import fandaNahled from "./fanda-nahled-web.png"
import zavislakNahled from "./zavislak-nahled-web.png"
import pozadiNerd from "./pozadi-nerd.png"
import pozadiKarel from "./pozadi-karel.png"
import pozadiJosef from "./pozadi-josef.png"
import pozadiFanda from "./pozadi-fanda.png"
import pozadiZavislak from "./pozadi-zavislak.png"
import pozadiZbysek from "./pozadi-zbysek.png"
import zbysekNahled from "./zbysek-nahled-web.png"


export type Postava = {
  id: number
  jmeno: string
  kofein_limit: number
  cookies_za_klik_start: number
  ma_autoclicker: boolean
  autoclicker_cookies_za_sec?: number
  slogan: string
  nahled: string
  pozadi: string
}

export const postavy: Postava[] = [
  { id: 1, jmeno: "Nerdoslav", kofein_limit: 900, cookies_za_klik_start: 3, ma_autoclicker: false, autoclicker_cookies_za_sec: 1, slogan: "Žena? To je nemoc nebo tak něco?", nahled: nerdNahled, pozadi: pozadiNerd },
  { id: 2, jmeno: "Důchodce Josef", kofein_limit: 950, cookies_za_klik_start: 4, ma_autoclicker: true, autoclicker_cookies_za_sec: 0, slogan: "Za mých časů se klikalo jen myší.", nahled: josefNahled, pozadi: pozadiJosef },
  { id: 3, jmeno: "Katana Karel", kofein_limit: 1100, cookies_za_klik_start: 5, ma_autoclicker: false, autoclicker_cookies_za_sec: 0, slogan: "Chodím po špičkách, už mě dost bolí.", nahled: karelNahled, pozadi: pozadiKarel },
  { id: 4, jmeno: "Streamer Fanda", kofein_limit: 1250, cookies_za_klik_start: 1, ma_autoclicker: true, autoclicker_cookies_za_sec: 5, slogan: "To není že bych byl špatnej, jen ta hra je špatná.", nahled: fandaNahled, pozadi: pozadiFanda },
  { id: 5, jmeno: "Závislák Luďa", kofein_limit: 1800, cookies_za_klik_start: 3, ma_autoclicker: true, autoclicker_cookies_za_sec: 2, slogan: "Já kdybych chtěl, tak s tím klidně přestanu, fakt.", nahled: zavislakNahled, pozadi: pozadiZavislak },
  { id: 6, jmeno: "Programátor Zbyšek", kofein_limit: 1550, cookies_za_klik_start: 1, ma_autoclicker: true, autoclicker_cookies_za_sec: 20, slogan: "Nebojte, já si to vymačkám.", nahled: zbysekNahled, pozadi: pozadiZbysek },
]
